import hasClass from './hasClass';

const addClass = function (ele, cls) {
    if (ele) {
        if (!hasClass(ele, cls)) {
            ele.className += ` ${cls}`;
        }
    }
};
export default addClass;
